import {Subject} from 'rxjs';
import type {ToUiMsg, FromUiMsg} from '@/types';

export const uiMsg$ = new Subject<FromUiMsg>();
export const toUiMsg$ = new Subject<ToUiMsg>();

addEventListener('message', ({data}) => uiMsg$.next(data));
toUiMsg$.subscribe((msg) => postMessage(msg));
